import store from '@/store'
export default (to, from, next) => {
  console.log(store.getters.loggedInUser)
  if(store.getters.loggedInUser && store.getters.loggedInUser.dealerId){
    console.log('여기')
    next()
  } else next('/app/sessions/log-in')
}
